import { render, staticRenderFns } from "./PostLinkPreview.vue?vue&type=template&id=132db358&scoped=true&"
import script from "./PostLinkPreview.vue?vue&type=script&lang=js&"
export * from "./PostLinkPreview.vue?vue&type=script&lang=js&"
import style0 from "./PostLinkPreview.vue?vue&type=style&index=0&id=132db358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132db358",
  null
  
)

export default component.exports